// extracted by mini-css-extract-plugin
export default {"dynamic-preannotations-control":"lsf-dynamic-preannotations-control"};
    if(module.hot) {
      // 1637785517380
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  